import React from 'react'
import {Row, Col, Table, Typography} from 'antd'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(weekday)

const {Title} = Typography

const fieldLabels = {
  position_accuracy: 'Position Accuracy',
  speed: 'Speed',
  speed_accuracy: 'Speed Accuracy',
  heading: 'Heading',
  heading_accuracy: 'Heading Accuracy',
  voltage: 'Voltage',
  current: 'Current'
}

const formatDate = ts => dayjs(ts).utc().format('ddd M/D/YY HH:mm') // Use .local() if timestamps are local already

const RailGWStatusSummary = ({data, limit, setLimit}) => {
  if (!data) return null

  const {begin, end, current, average} = data

  const columns = [
    {
      title: '',
      dataIndex: 'label',
      key: 'label'
    },
    {
      title: 'Current',
      dataIndex: 'current',
      key: 'current',
      align: 'right'
    },
    {
      title: 'Average *',
      dataIndex: 'average',
      key: 'average',
      align: 'right'
    }
  ]

  const tableData = Object.keys(current).map(field => ({
    key: field,
    label: fieldLabels[field] || field,
    current: current[field].toFixed(2),
    average: average[field].toFixed(2)
  }))

  return (
    <div style={{marginTop: 0}}>
      <Row justify="center" style={{marginBottom: 0}}>
        <Col>
          <Title level={4} style={{marginTop: 0}}>
            {begin && end ? `${formatDate(begin)} - ${formatDate(end)}` : 'No Rail Gateway Status Data'}
          </Title>
        </Col>
      </Row>
      <Table columns={columns} dataSource={tableData} pagination={false} bordered size="middle" />
      <p>
        * Average over the last{' '}
        <select value={limit} onChange={e => setLimit(parseInt(e.target.value))}>
          {[10, 20, 30, 40, 50, 100, 200].map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>{' '}
        unique locations
      </p>
    </div>
  )
}

export default RailGWStatusSummary
